/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { mediaBreakpoints } from '../../common/responsive';

export const styles = StyleSheet.create({
  formWrapper: {
    [mediaBreakpoints.mobile]: {
      height: '100%',
    },
  },
  formContainer: {
    [mediaBreakpoints.mobile]: {
      height: '100%',
    },
  },
});

export namespace TaskForm {
  export interface Props {
    onSubmit: React.HTMLAttributes<HTMLFormElement>['onSubmit'];
    formTemplate: React.ReactNode;
  }
}

export const TaskForm: React.FC<TaskForm.Props> = ({ onSubmit, formTemplate }) => {
  return (
    <div className={css(styles.formWrapper)}>
      <form onSubmit={onSubmit} noValidate data-it="Form-Form" className={css(styles.formContainer)}>
        {formTemplate}
      </form>
    </div>
  );
};
